
import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const ChildrenFAQ = () => {
  const faqs = [
    {
      question: "I hvilken alder kan børn begynde at spille klaver?",
      answer: "Generelt anbefaler jeg at børn starter med klaverundervisning omkring 6-7 års alderen, hvor de har den nødvendige finmotorik og koncentrationsevne. Dog kan nogle børn være klar tidligere, mens andre har gavn af at vente lidt længere. Vi kan altid arrangere en uforpligtende møde for at vurdere dit barns parathed."
    },
    {
      question: "Har vi brug for et klaver derhjemme for at starte undervisning?",
      answer: "For at opnå gode resultater er regelmæssig øvning essentiel, så adgang til et instrument derhjemme er vigtigt. Det behøver ikke være et dyrt akustisk klaver til at begynde med - et digitalt keyboard med vægtede tangenter kan være en udmærket start. Jeg kan rådgive om passende instrumenter til forskellige aldre og niveauer."
    },
    {
      question: "Hvor meget skal mit barn øve derhjemme?",
      answer: "For yngre børn (6-8 år) anbefaler jeg 15-20 minutters øvning 4-5 dage om ugen. For ældre børn øges det gradvist. Kvalitet er vigtigere end kvantitet, især i begyndelsen. Jeg giver altid klare øveanvisninger og strukturerede øverutiner, der passer til barnets alder og niveau."
    },
    {
      question: "Skal forældre være til stede under undervisningen?",
      answer: "For yngre børn kan det være gavnligt at en forælder er til stede de første par gange for at skabe tryghed. Derefter afhænger det af det enkelte barn og familiens præferencer. Uanset hvad, giver jeg altid forældre opdateringer om fremskridt og øvefokus efter hver lektion."
    },
    {
      question: "Hvordan holder du børn motiverede til at spille klaver?",
      answer: "Jeg bruger en kombination af kreative metoder: udvælgelse af musik børn kan relatere til, belønningssystemer, mini-mål med fejringer, jævnlige 'koncerter' for familie, og en legende tilgang til tekniske udfordringer. Jeg tilpasser altid min metode til det enkelte barns personlighed og interesser."
    }
  ];

  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-serif font-bold mb-8 text-center">
            Ofte stillede spørgsmål om klaverundervisning for børn
          </h2>
          
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left font-medium">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default ChildrenFAQ;
